import loadModuleOnScroll from "../../utils/loadModuleOnScroll";

export default function bodyImageSharesLoader(context) {
    loadModuleOnScroll(() => {
        import("./bodyImageShares").then((module) => module.default(context.settings));
    });
    return context;
}
